// This file corresponds with src\app\trueup\monthly-calculations\export-monthly-true-up-calculation-filter-representation.ts

import { CollectionsFilterRepresentation } from './collections-filter-representation-base';
import { CollectionsFilterProperties } from './collections-filter-properties';

export class ExportCollectionsFilterRepresentation {
    CollectionsFilterRepresentation: CollectionsFilterRepresentation = undefined;
    CollectionsFilterProperties: CollectionsFilterProperties = undefined;
}
